module.exports = __webpack_public_path__ + "static/media/blogo.5baccbf0.png";